<template>
  <div class="query-main">
    <img class="certificate-title" src="./../assets/img/certificate-title.png" alt="" />
    <div class="query-box">
      <ul class="qu-tab-tilte">
        <li @click="activea = 0" :class="{ active: activea == 0 }">
          <span>证书查询</span>
        </li>
        <!-- <li @click="activea = 1" :class="{ active: activea == 1 }">
          <span>成绩查询</span>
        </li> -->
      </ul>
      <div class="qu-tab-content">
        <div v-show="activea == 0">
          <Form :model="formItem" :rules="ruleValidate" :label-width="100">
            <Row>
              <Col span="12">
              <FormItem label="查询类别：">
                <Select @on-change="GetTData" v-model="GetCertForm.Type">
                  <Option v-for="item in TypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="岗       位：">
                <Select v-model="GetCertForm.Post">
                  <Option v-for="item in PostList" :value="item.Id" :key="item.Id">{{ item.Name }}</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="学员姓名：">
                <Input v-model="GetCertForm.Name"></Input>
              </FormItem>
              </Col>
            </Row>
            <div class="hex"></div>
            <Row>
              <Col span="12">
              <FormItem label="身  份  证：">
                <Input v-model="GetCertForm.PersionId"></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem prop="zsbh" label="证书编号：">
                <Input v-model="GetCertForm.Cert"></Input>
              </FormItem>
              </Col>
            </Row>
            <p class="bez">证书编号为必填</p>
            <div class="query-btn" @click="GetCertificate">点击查询</div>
          </Form>
        </div>
        <div v-show="activea == 1">
          <Form :model="formItem" :label-width="100">
            <Row style="margin-top: 30px">
              <Col span="12">
              <FormItem label="学员姓名：">
                <Input v-model="formItem.input4"></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="身份证号：">
                <Input v-model="formItem.input5"></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="岗位名称：">
                <Select v-model="formItem.select3"> </Select>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="准考证号：">
                <Input v-model="formItem.input6"></Input>
              </FormItem>
              </Col>
            </Row>
          </Form>
          <div class="query-btn" style="margin-top: 40px" @click="warning">
            点击查询
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="modal1" width="800" :footer-hide="true" title="证书信息">
      <div class="zsmain">
        <img class="zsmain-img" :src="base64img" style="width: 100%" alt="" />
      </div>
    </Modal>

    <Modal v-model="modal2" :footer-hide="true" title="证书信息">
      <div>
        <img :src="base64img2" style="width: 100%" alt="" />
      </div>
    </Modal>
  </div>
</template>

<script>
import { GetCertificateInfo, GetBaDaYuanCertificateInfo } from "@/api/news";
export default {
  data() {
    return {
      modal1: false,
      modal2: false,
      base64img: "",
      base64img2: "",
      activea: 0,
      GetCertForm: {
        Name: "",
        Type: "",
        PersionId: "",
        Post: "",
        Cert: "",
      },
      TypeList: [
        {
          value: "3",
          label: "三类人员继续教育",
        },
        {
          value: "36",
          label: "燃气从业人员",
        },
        {
          value: "34",
          label: "三类人员考前培训",
        },
        // {
        //   value: "35",
        //   label: "八大员证书",
        // },
      ],
      PostList2: [
        {
          Id: "1",
          TId: "11",
          Name: "建筑工程",
        },
        {
          Id: "2",
          TId: "11",
          Name: "公路工程",
        },
        {
          Id: "3",
          TId: "11",
          Name: "水利水电工程",
        },
        {
          Id: "4",
          TId: "11",
          Name: "市政公用工程",
        },
        {
          Id: "5",
          TId: "11",
          Name: "矿业工程",
        },
        {
          Id: "6",
          TId: "11",
          Name: "机电工程",
        },
        {
          Id: "7",
          TId: "3",
          Name: "主要负责人",
        },
        {
          Id: "8",
          TId: "3",
          Name: "项目负责人",
        },
        {
          Id: "9",
          TId: "3",
          Name: "专职安全生产管理人员",
        },
        {
          Id: "59",
          TId: "34",
          Name: "主要负责人",
        },
        {
          Id: "60",
          TId: "34",
          Name: "项目负责人",
        },
        {
          Id: "61",
          TId: "34",
          Name: "专职安全生产管理人员",
        },
        {
          Id: "1",
          TId: "35",
          Name: "土建施工员",
        },
        {
          Id: "2",
          TId: "35",
          Name: "装饰装修施工员",
        },
        {
          Id: "3",
          TId: "35",
          Name: "设备安装施工员",
        },
        {
          Id: "4",
          TId: "35",
          Name: "市政工程施工员",
        },
        {
          Id: "5",
          TId: "35",
          Name: "土建质量员",
        },
        {
          Id: "6",
          TId: "35",
          Name: "装饰装修质量员",
        },
        {
          Id: "7",
          TId: "35",
          Name: "设备安装质量员",
        },
        {
          Id: "8",
          TId: "35",
          Name: "市政工程质量员",
        },
        {
          Id: "9",
          TId: "35",
          Name: "材料员",
        },
        {
          Id: "10",
          TId: "35",
          Name: "机械员",
        },
        {
          Id: "11",
          TId: "35",
          Name: "劳务员",
        },
        {
          Id: "12",
          TId: "35",
          Name: "资料员",
        },
        {
          Id: "13",
          TId: "35",
          Name: "标准员",
        },
        {
          Id: "62",
          TId: "36",
          Name: "液化石油气库站运行工"
        },
        {
          Id: "63",
          TId: "36",
          Name: "压缩天然气场站运行工"
        },
        {
          Id: "64",
          TId: "36",
          Name: "燃气用户安装检修工"
        },
        {
          Id: "65",
          TId: "36",
          Name: "燃气输配场站运行工"
        },
        {
          Id: "66",
          TId: "36",
          Name: "液化天然气储运工"
        },
        {
          Id: "67",
          TId: "36",
          Name: "汽车加气站操作工"
        },
        {
          Id: "70",
          TId: "36",
          Name: "燃气管网运行工"
        },
        {
          Id: "81",
          TId: "36",
          Name: "企业主要负责人"
        },
        {
          Id: "82",

          TId: "36",
          Name: "安全生产管理人员"
        },
        {
          Id: "83",
          TId: "36",
          Name: "瓶装燃气送气工"
        },
      ],
      PostList: [],
      formItem: {
        zsbh: "",
        input1: "",
        input2: "",
        input3: "",
        input4: "",
        input5: "",
        input6: "",
        select1: "",
        select2: "",
        select3: "",
      },
      ruleValidate: {
        //  zsbh:
        //   [
        //     { required: true, message: '请输入证书编号', trigger: 'blur' }
        //       ],
      },
    };
  },
  //
  methods: {
    GetTData(item) {
      console.log(item);
      this.PostList = [];
      let data = JSON.parse(JSON.stringify(this.PostList2));
      this.PostList = data.filter((s) => s.TId === item);
    },
    warning() {
      this.$Message.warning("暂未开放");
    },
    GetCertificate() {
      if (this.GetCertForm.Cert === "") {
        this.$Message.warning("请输入证书编号");
        return;
      }
      if (this.GetCertForm.Post === "") {
        this.$Message.warning("请选择岗位");
        return;
      }
      if (this.GetCertForm.Type === "35") {
        this.$Spin.show();
        GetBaDaYuanCertificateInfo(this.GetCertForm).then((res) => {
          console.log(res.data);
          if (res.success) {
            this.base64img2 = res.data.data;
            this.$Spin.hide();
            this.modal2 = true;
          } else {
            // errmsg
            this.$Spin.hide();
            this.$Message.error({
              content: res.data.errmsg,
              duration: 3,
            });
          }
        });
      } 
   else  if (this.GetCertForm.Type === "36") {
        this.$Spin.show();
        GetCertificateInfo(this.GetCertForm).then((res) => {
          console.log(res.data);
          if (res.success) {
            this.base64img2 = res.data.pdfBase64string;
            this.$Spin.hide();
            this.modal2 = true;
          } else {
            // errmsg
            this.$Spin.hide();
            this.$Message.error({
              content: res.data.errmsg,
              duration: 3,
            });
          }
        });
      }     
      else {     
        this.$Spin.show();
        GetCertificateInfo(this.GetCertForm).then((res) => { 
          if (res.success) {
            this.base64img = res.data.pdfBase64string;
            console.log(res);
            this.$Spin.hide();
            this.modal1 = true;
          } else {
            this.$Spin.hide();
            this.$Message.error({
              content: res.data.msg,
              duration: 3,
            });
          }
        });
      }
    },
  },
};
</script>

<style>
.zsmain {
  position: relative;
  height: 500px;
  overflow: hidden;
}

.zsmain-img {
  position: absolute;
  top: -90px;
}
</style>


// WEBPACK FOOTER //
// src/components/query.vue